import SanityImage from './media/SanityImage.client';
import sanityConfig from '../../sanity.config';

interface RockerImageProps {
  component: any;
  skiTest: any;
}

export function RockerImage({component, skiTest}: RockerImageProps) {
  return (
    <div className="inset-image full-width md:py-14 md:-my-10 px-5 md:ml-[40px]">
      <SanityImage
        className="md:w-[90%] rounded-lg mb-4"
        dataset={sanityConfig.dataset}
        projectId={sanityConfig.projectId}
        src={component.image?.asset._ref}
        layout="fill"
      />
      <span className="font-libre-baskerville italic">
        The Rocker / Camber / Rocker profile of the {skiTest?.name}
      </span>
    </div>
  );
}
